import { useHistory } from 'react-router-dom';
import { getUidFromHref } from 'utils';

export const usePreviewPerson = () => {
  const history = useHistory();

  const previewPerson = ({ href }: { href?: string }) => {
    const uid = getUidFromHref(href);
    if (uid) {
      history.push(`/details/people/uid/${uid}`);
    }
  };
  return {
    previewPerson,
  };
};
